import React from "react";
import "./JubenshaItemModal.css";

export default function JubenshaItemModal({ 
  item, 
  onClose, 
  sourceType = null, // 'inventory' | 'slot'
  slotId = null,
  onMoveToSlot = null,
  onMoveToInventory = null,
  onRemove = null,
  availableSlots = []
}) {
  if (!item) return null;

  const normalized = typeof item === "string" ? { title: item } : item || {};
  const title = normalized.title || normalized.name || normalized.id || "Item";
  const description = normalized.subtitle || normalized.description || normalized.note || "No description.";
  const iconUrl = normalized.iconUrl || "https://placehold.co/96x96?text=ITEM";
  const itemId = normalized.id;
  const isEmpty = normalized.id === "empty";

  const handleMoveToSlot = () => {
    if (onMoveToSlot && itemId) {
      onMoveToSlot(itemId);
    }
  };

  const handleMoveToInventory = () => {
    if (onMoveToInventory && slotId) {
      onMoveToInventory(slotId);
    }
  };

  const handleRemove = () => {
    if (onRemove && itemId) {
      if (window.confirm(sourceType === 'slot' ? "Are you sure you want to discard this equipment?" : "Are you sure you want to discard this item?")) {
        onRemove(itemId, slotId);
      }
    }
  };

  return (
    <div className="item-modal-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="item-modal" onClick={(e) => e.stopPropagation()}>
        <div className="item-modal-head">
          <div className="item-modal-title">{title}</div>
          <button className="item-modal-close" onClick={onClose} aria-label="Close"><span aria-hidden="true">&#10005;</span></button>
        </div>
        <div className="item-modal-body">
          <img src={iconUrl} alt={title} className="item-modal-icon" />
          <div className="item-modal-text">
            <div className="item-modal-description">{description}</div>
            {normalized.note && <div className="item-modal-meta">Note: {normalized.note}</div>}
            {sourceType === 'slot' && normalized.slotLabel && (
              <div className="item-modal-meta">Slot: {normalized.slotLabel}</div>
            )}
          </div>
        </div>
        {!isEmpty && sourceType && (
          <div className="item-modal-actions">
            {sourceType === 'inventory' && onMoveToSlot && (
              <button className="item-modal-action-btn" onClick={handleMoveToSlot}>
                ⚙️ Move to Slot
              </button>
            )}
            {sourceType === 'slot' && onMoveToInventory && (
              <button className="item-modal-action-btn" onClick={handleMoveToInventory}>
                📦 Move to Inventory
              </button>
            )}
            {onRemove && (
              <button className="item-modal-action-btn item-modal-action-remove" onClick={handleRemove}>
                🗑️ Discard Item
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
